import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";
import DetermineAgeForm from "../../../components/PMWork/BindContract/DetermineAgeForm";
import BindContractBranchForm from "../../../components/PMWork/BindContract/BindContractBranchForm";
import BranchSerialNumberForm from "../../../components/PMWork/BindContract/BranchSerialNumberForm";
import CusBranchsService from "../../../services/cusbranch.service";
import ProdSetMcsService from "../../../services/prodsetmc.service";
import DefineAgeEquipsService from "../../../services/defineageequips.service";
import StickerDateForm from "../../../components/PMWork/BindContract/StickerDateForm";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";

export default function AddBindingPMServiceContract() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();

  useEffect(() => {
    const key =
      (state?.type ? `${state?.name}.${state?.type}` : state?.name) || "branch";
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        branch: "เพิ่มสินค้าให้สาขา",
        binding: "ผูกสัญญากับสินค้า",
        machine: "ข้อมูลสาขาที่จะสร้างหมายเลขเครื่องและเพิ่มรายละเอียดอื่นๆ",
        determine: {
          age: "เพิ่มข้อมูลอายุอุปกรณ์/อะไหล่่",
          sticker: "เพิ่มข้อมูล Sticker Date"
        }
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta
          name="description"
          content="Add Binding a contract with the product Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="branch" title="ผูกสัญญากับสาขา">
            {websiteName === "เพิ่มสินค้าให้สาขา" && (
              <BindContractBranchForm
                onSubmitCallback={(data) =>
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: CusBranchsService.createCusBranchs(data),
                    navigated: (navi) => navi && navigate(0)
                  })
                }
              />
            )}
          </Tab>
          <Tab eventKey="binding" title="ผูกสัญญากับสินค้า"></Tab>
          <Tab eventKey="machine" title="กำหนดหมายเลขเครื่อง">
            {websiteName ===
              "ข้อมูลสาขาที่จะสร้างหมายเลขเครื่องและเพิ่มรายละเอียดอื่นๆ" && (
              <BranchSerialNumberForm
                onSubmitCallback={(data) =>
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: ProdSetMcsService.createProdSetMcs(data),
                    navigated: (navi) => {
                      if (navi) {
                        navigate("/PM_work/bind/create", {
                          state: { name: "machine" }
                        });
                        navigate(0);
                      }
                    }
                  })
                }
              />
            )}
          </Tab>
          <Tab eventKey="determine" title="กำหนดอายุอุปกรณ์/อะไหล่">
            {websiteName === "เพิ่มข้อมูลอายุอุปกรณ์/อะไหล่่" && (
              <DetermineAgeForm
                onSubmitCallback={(data) =>
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest:
                      DefineAgeEquipsService.createDefineAgeEquips(data),
                    navigated: (navi) => navi && navigate(0)
                  })
                }
              />
            )}
            {websiteName === "เพิ่มข้อมูล Sticker Date" && (
              <StickerDateForm
                onSubmitCallback={(data) =>
                  data.Array.map(({ Id, ...item }, idx) => {
                    addEditServiceRequest({
                      showAlert,
                      setLoading,
                      serviceRequest:
                        DefineAgeEquipsService.editDefineAgeEquips(Id, item),
                      navigated: (navi) =>
                        navi && idx === data.Array.length - 1 && navigate(0)
                    });
                  })
                }
              />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
